<template>
	<div class="row">
		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('cadAeronave', 'tailNumber') }}:</label>
			<br />
			<p>{{ aeronave.prefixo }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('cadAeronave', 'codinome') }}:</label>
			<br />
			<p>{{ aeronave.codinome }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('global', 'categoria') }}:</label>
			<br />
			<p>{{ aeronave.categoria }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('global', 'tipo') }}:</label>
			<br />
			<p v-if="aeronave.tipo == 'H'">{{ _traducao('cadAeronave', 'helicoptero').toUpperCase() }}</p>
			<p v-if="aeronave.tipo == 'A'">{{ _traducao('cadAeronave', 'aviao').toUpperCase() }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('cadAeronave', 'fabricante') }}:</label>
			<br />
			<p>{{ aeronave.fabricante }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('cadAeronave', 'modelo') }}:</label>
			<br />
			<p>{{ aeronave.modelo }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('cadAeronave', 'serialNumber') }}:</label>
			<br />
			<p>{{ aeronave.serial_number == null || aeronave.serial_number == '' ? 'N/A' : aeronave.serial_number }}</p>
		</div>

		<div class="col-xs-6 col-md-2">
			<label>{{ _traducao('global', 'data') }}:</label>
			<br />
			<p>
				{{ trecho.acionamento == '' || trecho.acionamento == null ? 'N/A' : trecho.acionamento.split(' ')[0] | data }}
			</p>
		</div>

		<div class="col-xs-12 col-md-6">
			<label>{{ _traducao('global', 'numero') }}:</label>
			<br />
			<p>{{ trecho.numero_diario == null ? 'GERADO APÓS O PREENCHIMENTO' : trecho.numero_diario }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InformacoesAeronave',

	props: {
		aeronave: {
			type: Object,
			default: () => ({}),
			required: true
		},

		trecho: {
			type: Object,
			default: () => ({}),
			required: true
		}
	}
}
</script>